var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "catalog-content" } },
    [
      _c("b-row", [
        _c(
          "div",
          { staticClass: "col-md-9" },
          [
            _vm.catalogForm
              ? _c(
                  "b-tabs",
                  _vm._l(_vm.languages, function (lang, i) {
                    return _c(
                      "b-tab",
                      { key: i, attrs: { title: lang.name } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.catalogForm.languageContent[lang.code].name,
                              expression:
                                "catalogForm.languageContent[lang.code].name",
                            },
                          ],
                          staticClass: "inputTitle",
                          domProps: {
                            value:
                              _vm.catalogForm.languageContent[lang.code].name,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.catalogForm.languageContent[lang.code],
                                "name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.data.type === "content"
                          ? _c("ckeditor", {
                              attrs: {
                                editor: _vm.editor,
                                config: _vm.editorConfig(),
                              },
                              model: {
                                value:
                                  _vm.catalogForm.languageContent[lang.code]
                                    .content,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.catalogForm.languageContent[lang.code],
                                    "content",
                                    $$v
                                  )
                                },
                                expression:
                                  "catalogForm.languageContent[lang.code].content",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "actionsButton",
                on: { click: _vm.updateContent },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.update")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        !!_vm.catalogForm
          ? _c("div", { staticClass: "col-md-3 content-statistics" }, [
              _c("h4", [_vm._v("İçerik Durum İstatistiği")]),
              _vm._v(" "),
              _c("div", { staticClass: "userInfo" }, [
                _c("div", { staticClass: "userInfo first" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.like")) +
                      " :\n                    "
                  ),
                  _c("span", { staticClass: "userInfo sec" }, [
                    _vm._v(_vm._s(_vm.catalogForm.rate.up)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "userInfo" }, [
                  _c("div", { staticClass: "userInfo first" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.disLike")) +
                        " :\n                        "
                    ),
                    _c("span", { staticClass: "userInfo sec" }, [
                      _vm._v(_vm._s(_vm.catalogForm.rate.down)),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }